export const callBacks = new Set();
export const cancellCallBacks = new Set();
export const addUnloadHandler = (handler) => {
    callBacks.add(handler);
};
export const removeUnloadHandler = (handler) => {
    callBacks.delete(handler);
};
export const addCancelUnloadHandler = (handler) => {
    cancellCallBacks.add(handler);
};
export const removeCancelUnloadHandler = (handler) => {
    cancellCallBacks.delete(handler);
};
//# sourceMappingURL=index.js.map